import DashboardComparativo from "./DashboardComparativoPage";

export {DashboardComparativo}
export default DashboardComparativo
